import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Catering from "./Catering";
import Facilities from "./Facilities";

const MainAddons = () => {
  const { t } = useTranslation("addons");
  const [activeComponent, setActiveComponent] = useState("catering");

  const handleCatering = () => {
    setActiveComponent("catering");
  };

  const handleFacilities = () => {
    setActiveComponent("facilities");
  };

  const renderComponent = () => {
    switch (activeComponent) {
      case "catering":
        return <Catering />;
      case "facilities":
        return <Facilities />;
      default:
        return <Catering />;
    }
  };

  return (
    <>
      <div className="head-addons">
        <h1 className="title-addons">{t("title")}</h1>
        <p className="addons-desc">{t("description")}</p>
        <div className="invitaion-btns">
          <button
            className={`catering-btn ${
              activeComponent === "catering" ? "active" : ""
            }`}
            onClick={handleCatering}
          >
            {t("buttons.catering")}
          </button>
          <button
            className={`facilities-btn ${
              activeComponent === "facilities" ? "active" : ""
            }`}
            onClick={handleFacilities}
          >
            {t("buttons.facilities")}
          </button>
        </div>
      </div>
      <div className="component-container">{renderComponent()}</div>
    </>
  );
};

export default MainAddons;
